import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('issuer', '/issuers')
const actions = generator.generate()

export default actions
